export enum CandidacyAwardFinalPosition {
  WINNER = 'WINNER',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
  FINALIST = 'FINALIST',
}
